export enum OFFER_TYPE {
	LEASE = 'lease',
	FINANCE = 'finance',
	CASH = 'cash',
	OFF_MSRP = 'off_msrp',
}

export const OFFER_TYPE_NICE_NAME = {
	[OFFER_TYPE.LEASE]: 'Lease',
	[OFFER_TYPE.FINANCE]: 'Finance',
	[OFFER_TYPE.CASH]: 'Cash',
	[OFFER_TYPE.OFF_MSRP]: 'Off MSRP',
};

export enum SUB_CATEGORY {
	TOTAL_SAVINGS = 'total savings',
}

export interface BaseOffer {
	id: string;
	vin: string;
	car_year: string;
	car_make: string;
	car_model: string;
	car_trim: string;
	category: OFFER_TYPE;
	img: string;
	car_title: string;
	custom_text?: string | null;
	terms: string;
	type: string; // website|oem|ignite
	is_in_transit?: boolean;
	selling_price?: string;
}

export interface LeaseOffer extends BaseOffer {
	lease_amount_per_month: string;
	lease_months: string;
	lease_due_at_signing?: string;
	lease_down_payment?: string;
	security_deposit?: string;
}

export interface FinanceOffer extends BaseOffer {
	finance_apr: string;
	finance_months: string;
	finance_amount_per_month?: string;
	finance_down_payment?: string;
}
export interface CashOffer extends BaseOffer {
	cash_amount: string;
	sub_category?: string;
}

export interface MsrpOffer extends BaseOffer {
	off_amount: string;
}

export type OfferModel = LeaseOffer | FinanceOffer | CashOffer | MsrpOffer;

export enum OFFER_SOURCE {
	OEM = 'oem',
	CSV = 'csv',
	IGNITE = 'ignite',
}

export const OFFER_SOURCE_TO_FTC_KEY = {
	[OFFER_SOURCE.OEM]: 'oem_offers',
	[OFFER_SOURCE.CSV]: 'dealer_offers',
	[OFFER_SOURCE.IGNITE]: 'dynamic_payments_offers',
} as const;
